"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const react_1 = __importStar(require("react"));
const overclaim_1 = require("@App/api/routes/overclaim");
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const UploadDocumentConfirmationPopup = (props) => {
    const { rightsholderStore, popupStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { uploadedFiles, setFilesWereUploaded, onClose } = props;
    const [isUploading, setIsUploading] = (0, react_1.useState)(false);
    const params = (0, react_router_dom_1.useParams)();
    const overclaimHeaderId = params.overclaimHeaderId && +params.overclaimHeaderId;
    const rightsholderId = rightsholderStore.currentRightsholderId;
    const uploadDocuments = () => {
        setIsUploading(true);
        preloaderStore.openTransparentPreloader(true);
        uploadedFiles.map((file) => __awaiter(void 0, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file);
            try {
                if (overclaimHeaderId !== undefined) {
                    const response = yield (0, overclaim_1.generateOverclaimDocumentUploadUrl)(rightsholderId, overclaimHeaderId, file.name, file.size, file.description);
                    yield (0, overclaim_1.uploadOverclaimDocumentToS3)(response.data.presignedUrl, file, file.type);
                    setFilesWereUploaded(true);
                }
            }
            catch (ignore) {
                popupStore.setAlertData('Unable to upload file', true);
            }
            finally {
                onClose();
                setIsUploading(false);
                preloaderStore.openTransparentPreloader(false);
            }
        }));
    };
    return (react_1.default.createElement(Popup_1.default, { onClose: onClose },
        react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Upload Documentation', onCancel: onClose, cancelButtonText: 'Cancel', disabled: isUploading, onConfirm: uploadDocuments, confirmButtonText: 'Confirm' },
            react_1.default.createElement("p", null,
                "Please note: Any documentation provided to The MLC may be shared internally within The MLC and externally with other Claimant(s) involved in the Conflict Procedure, including their agents and representatives.",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                " Please review The MLC's",
                ' ',
                react_1.default.createElement("a", { href: 'https://www.themlc.com/policies', target: '_blank', rel: 'noreferrer noopener' },
                    "Dispute Policy",
                    ' '),
                "for more information."))));
};
exports.default = UploadDocumentConfirmationPopup;
